// eslint-disable-next-line import/prefer-default-export
export const round = (num, decimals = 2) => {
    const rounded = Math.round(num * 10 ** decimals + Number.EPSILON) / 10 ** decimals;
    if (rounded === 10) return rounded.toFixed(decimals > 0 ? decimals - 1 : decimals);
    return rounded.toFixed(decimals);
};
